interface UploadGCSSignedUrlOpts {
  writeUrl: string;
  blob: Blob;
  contentType: string;
  maxBytes: number;
  acl: string | null;
}

export default ({
  writeUrl,
  blob,
  contentType,
  maxBytes,
  acl,
}: UploadGCSSignedUrlOpts) =>
  fetch(writeUrl, {
    method: 'PUT',
    body: blob,
    headers: {
      'content-type': contentType,
      'cache-control': 'public, max-age=86400',
      'x-goog-content-length-range': `0,${maxBytes}`,
      ...(acl ? { 'x-goog-acl': acl } : {}),
    },
  }).then((response) => {
    if (response.ok) return response;
    throw new Error(`Failed to upload ${contentType}: ${response.status}`);
  });
